import React, { ReactNode } from "react";

interface MobileMockupProps {
  children: ReactNode;
  width?: number;
  height?: number;
  className?: string;
}

export const MobileMockup = ({
  children,
  width = 411,
  height = 833,
  className = "",
}: MobileMockupProps) => {
  // Calculate scaling factors based on default dimensions (411x833)
  const scaleX = width / 411;
  const scaleY = height / 833;

  // Calculate content area dimensions proportionally
  const contentWidth = 375 * scaleX;
  const contentHeight = 812 * scaleY;
  const contentLeft = 17.5 * scaleX;
  const contentTop = 9 * scaleY;
  const borderRadius = 40 * Math.min(scaleX, scaleY); // Scale border radius

  return (
    <div
      className={`relative inline-block ${className}`}
      style={{ width, height }}
    >
      {/* ...SVG frame... */}
      <svg
        width={width}
        height={height}
        viewBox="0 0 411 833"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute inset-0 z-[4] pointer-events-none"
      >
        {/* Phone border and frame */}
        <rect
          x="12.5312"
          y="5.39905"
          width="385"
          height="822"
          rx="45"
          stroke="#37353E"
          strokeWidth="10"
          fill="none"
        />
        {/* Home indicator */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M146.031 814.399C146.031 813.018 147.151 811.899 148.531 811.899H260.531C261.912 811.899 263.031 813.018 263.031 814.399C263.031 815.78 261.912 816.899 260.531 816.899H148.531C147.151 816.899 146.031 815.78 146.031 814.399Z"
          fill="black"
        />
        {/* Volume buttons */}
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.53125 185.899C10.1211 185.899 13.0312 188.809 13.0312 192.399L13.0312 205.399C13.0312 208.989 10.1211 211.899 6.53125 211.899C2.9414 211.899 0.031249 208.989 0.0312491 205.399L0.0312497 192.399C0.0312499 188.809 2.9414 185.899 6.53125 185.899Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.53125 222.899C10.1211 222.899 13.0312 225.809 13.0312 229.399L13.0312 279.399C13.0312 282.989 10.1211 285.899 6.53125 285.899C2.9414 285.899 0.0312474 282.989 0.0312475 279.399L0.0312497 229.399C0.0312499 225.809 2.9414 222.899 6.53125 222.899Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.53125 296.899C10.1211 296.899 13.0312 299.809 13.0312 303.399L13.0312 353.399C13.0312 356.989 10.1211 359.899 6.53125 359.899C2.9414 359.899 0.0312474 356.989 0.0312475 353.399L0.0312497 303.399C0.0312499 299.809 2.9414 296.899 6.53125 296.899Z"
            fill="black"
          />
        </g>
        {/* Power button */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M403.531 183.899C407.121 183.899 410.031 186.809 410.031 190.399L410.031 289.399C410.031 292.989 407.121 295.899 403.531 295.899C399.941 295.899 397.031 292.989 397.031 289.399L397.031 190.399C397.031 186.809 399.941 183.899 403.531 183.899Z"
          fill="black"
        />
      </svg>
      {/* Content area */}
      <div
        className="absolute overflow-hidden"
        style={{
          left: `${contentLeft}px`,
          top: `${contentTop}px`,
          width: `${contentWidth}px`,
          height: `${contentHeight}px`,
          borderRadius: `${borderRadius}px`,
        }}
      >
        <div className="w-full h-full overflow-auto">{children}</div>
      </div>
    </div>
  );
};
